
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.07 6h17.444v17.39H6.07V6zm43.498 43.618H54V54h-4.432v-4.382zm-8.546 0h4.453v4.154h-8.9V45.25h4.288v-4.326h4.383v-8.626h4.467v4.237h4.232v4.382h-4.232v4.381h-8.691V49.618zm-13.2-8.764h4.308v-4.382H27.98v-4.381h4.149v-4.382H27.89v4.382h-4.453v-4.382h4.377V14.695h4.446v13.007h4.308v4.382h4.238v-4.382h4.446v4.382h-4.231v4.381h-4.446v8.626h-4.308v8.701h-4.446V40.854zm21.677-13.152h4.446v4.382h-4.446v-4.382zm-34.738 0h4.446v4.382H14.76v-4.382zm-8.692 0h4.446v4.382H6.07v-4.382zM27.822 6h4.446v4.382h-4.446V6zM6 36.535h17.438v17.389H6v-17.39zm4.239 4.236h8.988v8.937h-8.989v-8.937zM36.513 6.007h17.432v17.382H36.507V6l.006.007zm4.239 4.223h8.989v8.936h-8.99v-8.943.007zm-30.424 0h8.99v8.936h-8.99v-8.943.007z"}})])
          )
        }
      }
    